import { request } from '../request'
import { TimeZone } from '../types'

export class TimeZonesService {

  getTimeZones(): Promise<TimeZone[]> {
    return request.get(`/api/time_zones.json`)
  }

}
